import {ILightMapWizardState} from "../../../types/ui/wizard/light-map";
import {LightMapEditingMode} from "../../../types/types";
import {defaultLightEnvironment} from "../../../../peregrine/processor";

export const initialLightMapState: ILightMapWizardState = {
  mode: LightMapEditingMode.CreateNew,
  envMap: defaultLightEnvironment,
  orgEnvMap: defaultLightEnvironment
};
